var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('counsel-card-row', {
    attrs: {
      "label": "분야"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "3"
    }
  }, [_c('v-select', _vm._b({
    attrs: {
      "items": _vm.parents,
      "placeholder": "대분류를 선택해주세요",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', null);
      }
    },
    model: {
      value: _vm.$data._parent,
      callback: function callback($$v) {
        _vm.$set(_vm.$data, "_parent", $$v);
      },
      expression: "$data._parent"
    }
  }, 'v-select', _vm.selectProps, false))], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "lg": "3"
    }
  }, [_c('v-select', _vm._b({
    ref: "_area",
    attrs: {
      "items": _vm.children,
      "placeholder": "소분류를 선택해주세요",
      "disabled": !_vm.$data._parent,
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', _vm.$data._area);
      }
    },
    model: {
      value: _vm.$data._area,
      callback: function callback($$v) {
        _vm.$set(_vm.$data, "_area", $$v);
      },
      expression: "$data._area"
    }
  }, 'v-select', _vm.selectProps, false))], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }